export enum Risk {
  NONE = 'NONE',
  LOW = 'LOW',
  HIGH = 'HIGH',
}
